import React, { useState } from "react";
import "./Header.css";
import { useAssets } from "../../assets/AssetsContext";
import "../styles/styles.css";

function Header() {
  const assets = useAssets();
  const [isMenuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!isMenuOpen);
  const closeMenu = () => {
    setMenuOpen(false);
  };

  const scrollToTop = (e) => {
    e && e.preventDefault();
    setMenuOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="header-fixed">
      <div className="wrapper">
        <header className="header">
          <div className="logo">
            <a href="#home" onClick={scrollToTop}>
              <img src={assets.logo2} alt="Tributum Power Private Limited Logo" className="logo" />
            </a>
          </div>
          <button
            className="hamburger"
            onClick={toggleMenu}
            aria-label="Toggle navigation menu"
          >
            <img src={assets.Hamburger} alt="Menu" />
          </button>

          <div className={`menu-overlay ${isMenuOpen ? "open" : ""}`}>
            <button
              className="close-btn"
              onClick={closeMenu}
              aria-label="Close menu"
            >
              ×
            </button>
            <nav className="menu">
              <ul>
                <li onClick={scrollToTop}>
                  <a href="#home">Home</a>
                </li>
                <li onClick={closeMenu}>
                  <a href="#AtmosPOLE">About AtmosPOLE</a>
                </li>
                <li onClick={closeMenu}>
                  <a href="#how-it-works">How It Works</a>
                </li>
                <li onClick={closeMenu}>
                  <a href="#live-network">Live Network</a>
                </li>
                <li onClick={closeMenu}>
                  <a href="#media-coverage">Media Coverage</a>
                </li>
              </ul>
            </nav>
          </div>
        </header>
      </div>
    </div>
  );
}

export default Header;
